
import { createClient } from '@supabase/supabase-js';

// Use environment variables from the Supabase project
const supabaseUrl = "https://figlvsuqeuzsutxdvcoi.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpZ2x2c3VxZXV6c3V0eGR2Y29pIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1ODczMDcsImV4cCI6MjA2MTE2MzMwN30.IsIlRgC-L96ITqP5xgTE0fW4bEWEuXROU5PWReskn6A";

// ⚠️ This file is deprecated. Use the client from "@/integrations/supabase/client" instead
console.warn("Warning: Using deprecated Supabase client from src/lib/supabase.ts. Please update imports to use '@/integrations/supabase/client' instead.");

// Export the same client as the new one to avoid multiple instances
export { supabase } from '@/integrations/supabase/client';
